export const family = "'Spartan', sans-serif";
export const weight = 700;
export const size = "32px";

const font = { family, weight, size };
export default font;
